export const TYRES_OPC_DASHBOARD: string = 'dashboard';
export const TYRES_OPC_TYRES: string = 'tyres';
export const TYRES_OPC_CONTRACTS: string = 'tyre-contracts';
export const TYRES_OPC_MOVEMENT: string = 'movements';
export const TYRES_OPC_DETAIL: string = 'detail';
export const TYRES_OPC_TYRE_DETAIL: string = 'detail';
export const TYRES_OPC_CONTRACT_DETAIL: string = 'detail';
